import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CcamService } from 'src/app/services/facturation/ccam/ccam.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { Ccam } from 'src/app/utils/interfaces/new/ccam.interface';
import { CcamFilter } from 'src/app/utils/interfaces/new/filtre-ccam.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Modificateur } from 'src/app/utils/interfaces/new/modificateur.interface';
import { environment } from 'src/environments/environment';

interface SelectCode {
  doSelect: boolean;
  codeId: string;
}

@Component({
  selector: 'app-ccam',
  templateUrl: './ccam.fragment.html',
  styleUrls: [
    './ccam.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class CcamFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public favorisCcam = [];

  public selectedCode: any;
  public formGroup: FormGroup;
  public categoriesList = [{ id: 'Système nerveux central, périphérique et autonome', libelle: 'Système nerveux central' }, { id: 'Oeil et annexes', libelle: 'Oeil et annexes' }, { id: 'Système immunitaire et système hématopoïétique', libelle: 'Système immunitaire et système hématopoïétique' }, { id: 'Appareil circulatoire', libelle: 'Appareil circulatoire' }, { id: 'Appareil ostéoarticulaire et musculaire de la tête', libelle: 'Appareil ostéoarticulaire et musculaire de la tête' }];

  public listCCAMBodyTable = {
    page: 1,
    perpage: 10,
    total: 0,
    objects: []
  };
  public listCCAMColumnTable = [
    { title: 'Code', data: 'code' },
    { title: 'A', data: 'activite' },
    { title: 'P', data: 'phase' },
    { title: 'Libellé', data: 'libelle' },
    { title: 'Favoris', data: null }
  ];

  public CCAMDetailsBodyTable = {
    page: 1,
    perpage: 1,
    total: 1,
    objects: []
  };
  public CCAMDetailsColumnTable = [
    { title: 'Code', data: 'code' },
    { title: 'Chapitre', data: 'chapitre' },
    { title: 'Libellé', data: 'libelle' },
    { title: 'Code d\'activité', data: 'activite' },
    { title: 'Libellé d\'activité', data: 'activityLibelle' },
    { title: 'Code de phase', data: 'phase' },
    { title: 'Libellé de phase', data: 'phaseLibelle' },
    { title: 'Tarif', data: 'tarifSecteur' },
    { title: 'Remb. sou cond.', data: 'remboursement' },
    { title: 'Accord préalable', data: 'accord' },
    { title: 'Exo. tickets mod.', data: 'exoTm' },
    { title: 'Regroupement', data: 'regroupement' },
    { title: 'Code(s) modificateur(s)', data: 'modificateurs' },
    { title: 'Code(s) éventuel(s)', data: 'codeEv' },
  ];

  public filtreCcam: CcamFilter;
  public filtre: Filtres = {
    perpage: 10,
    currentPage: 1,
  };

  @Output() public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeCCAMModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
    private _modal: ModalService,
    private _view: ViewContainerRef,
    private _ccamService: CcamService
  ) { }

  async ngOnInit(): Promise<void> {
    this.formGroup = this._formBuilder.group({
      code: [''],
      nom: [''],
      categories: [''],
    });

    await this.getFavoris();
  }

  private async refreshCcamList() {
    let listCcam = await this._ccamService.findHypermed(this.filtre, this.filtreCcam);
    this.listCCAMBodyTable.objects = listCcam.objects.map((ccam: Ccam) => {
      return {
        id: ccam.id,
        activite: ccam.activite,
        phase: ccam.phase,
        code: ccam.code,
        accord: ccam.accord,
        description: ccam.description,
        exoTm: ccam.exoTm,
        regroupement: ccam.regroupement,
        specialite: ccam.specialite,
        tarifSecteur: ccam.tarifSecteur,
        tarifHorsSecteur: ccam.tarifHorsSecteur,
        remboursement: ccam.remboursement,
        codeEv: ccam.codeEv,
        libelle: ccam.libelle,
        modificateurs: ccam.modificateurs.map((modificateur: Modificateur) => (modificateur.libelle)),
      }
    });

    this.listCCAMBodyTable.total = listCcam.total;
    this.listCCAMBodyTable.page = listCcam.page;
  }

  private async getFavoris() {
    this.favorisCcam = await this._ccamService.findUser();
  }

  public onSubmit() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      this.listCCAMBodyTable.objects = [];
      this.CCAMDetailsBodyTable.objects = [];
      this.selectedCode = undefined;
      const code: string = this.formGroup.get('code').value;
      const categorie: string = this.formGroup.get('categories').value;
      const libelle: string = this.formGroup.get('nom').value;
      const filters: CcamFilter = {
        code: code ? code : '',
        libelle: libelle ? libelle : '',
        specialite: categorie ? categorie : ''
      }
      this.filtreCcam = filters;
      this.refreshCcamList();
    }
  }

  public addToFavorisCcam(event) {
    const fav = this.favorisCcam.find(x => x.id === event.id);
    if (fav) {
      this._modal.openAlert(this._view, 'Action impossible', 'Ce code fait déjà parti de vos favoris.');
    } else {
      const modal = this._modal.openModalConfirmation(this._view, 'Confirmation', 'Voulez-vous ajouter ce code à vos favoris ?');
      modal.instance.closeEmitter.subscribe(async (res: boolean) => {
        if (res) {
          const loadingModal = await this._modal.openLoading(this._view);
          try {
            await this._ccamService.create(event);
            this.getFavoris();
            this._modal.close(loadingModal);
          } catch (e) {
            this._modal.close(loadingModal);
            console.error(e);
          }
        }
      });
    }
  }

  public async onChangePage(value: any): Promise<void> {
    this.filtre.currentPage = value;
    this.refreshCcamList();
  }

  public codeSelected() {
    this.closeCCAMModal(this.selectedCode);
  }

  public closeCCAMModal(object?: any): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit();
    }
  }

  public selectUnseclectCode(event: any): void {
    if (this.selectedCode === event) {
      this._doSelectCode({ doSelect: false, codeId: event.id });
      this.selectedCode = undefined;
      this.CCAMDetailsBodyTable.objects = [];
    } else {
      if (this.selectedCode) {
        this._doSelectCode({ doSelect: false, codeId: this.selectedCode.id });
      }
      this.selectedCode = event;
      const clone = JSON.parse(JSON.stringify(event));
      this.CCAMDetailsBodyTable.objects = [clone];
      this._doSelectCode({ doSelect: true, codeId: event.id });
    }
  }

  private _doSelectCode(code: SelectCode): void {
    if (this.listCCAMBodyTable && this.listCCAMBodyTable.objects) {
      const index = this.listCCAMBodyTable.objects.findIndex(p => p.id === code.codeId);
      const codeDisplayTable = this.listCCAMBodyTable.objects.find(p => p.id === code.codeId);

      if (code.doSelect) {
        Object.defineProperty(codeDisplayTable, 'rowColor', { configurable: true, value: 'var(--primary)' });
        Object.defineProperty(codeDisplayTable, 'textColor', { configurable: true, value: 'var(--white)' });
      } else {
        Object.defineProperty(codeDisplayTable, 'rowColor', { configurable: true, value: 'transparent' });
        Object.defineProperty(codeDisplayTable, 'textColor', { configurable: true, value: 'var(--black)' });
      }

      this.listCCAMBodyTable.objects.splice(index, 1, codeDisplayTable);
    }
  }
}
